// import Vue from 'vue';
import { JSEncrypt } from './jsencrypt'
import { isString, isObject } from './types'

const publicRSAKey =
	'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCqDGLO0hs6YmJ6CXaKaHOxii8EcwAcWyPlVGtEW+SOed2UZV/QD5tMdLIS35qG6ufATQBr7ehFwxxtSxaWWOaze6PlEHvnk7yBX/Ey09QdRPez8t4SRsFEcIM6eA47Rbcu6WlqU6v1eq97XmkToNmaOQLpb3bhpHnm/X/th1scFwIDAQAB'
const rtrim = /^(\s|\u00A0)+|(\s|\u00A0)+$/g
const hasOwnProperty = Object.prototype.hasOwnProperty

export function trim(text) {
	return (text || '').replace(rtrim, '')
}

export function noop() {}

export function hasOwn(obj, key) {
	return hasOwnProperty.call(obj, key)
}

function extend(to, _from) {
	for (const key in _from) {
		to[key] = _from[key]
	}
	return to
}

export function toObject(arr) {
	const res = {}
	for (let i = 0; i < arr.length; i++) {
		if (arr[i]) {
			extend(res, arr[i])
		}
	}
	return res
}

export const getValueByPath = function (object, prop) {
	prop = prop || ''
	const paths = prop.split('.')
	let current = object
	let result = null
	for (let i = 0, j = paths.length; i < j; i++) {
		const path = paths[i]
		if (!current) break

		if (i === j - 1) {
			result = current[path]
			break
		}
		current = current[path]
	}
	return result
}

export function getPropByPath(obj, path, strict) {
	let tempObj = obj
	path = path.replace(/\[(\w+)\]/g, '.$1')
	path = path.replace(/^\./, '')

	const keyArr = path.split('.')
	let i = 0
	for (let len = keyArr.length; i < len - 1; ++i) {
		if (!tempObj && !strict) break
		const key = keyArr[i]
		if (key in tempObj) {
			tempObj = tempObj[key]
		} else {
			if (strict) {
				throw new Error('please transfer a valid prop path to form item!')
			}
			break
		}
	}
	return {
		o: tempObj,
		k: keyArr[i],
		v: tempObj ? tempObj[keyArr[i]] : null,
	}
}

export const generateId = function () {
	return Math.floor(Math.random() * 10000)
}

export const valueEquals = function (a, b) {
	// see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
	if (a === b) return true
	if (!(a instanceof Array)) return false
	if (!(b instanceof Array)) return false
	if (a.length !== b.length) return false
	for (let i = 0; i !== a.length; ++i) {
		if (a[i] !== b[i]) return false
	}
	return true
}

export const escapeRegexpString = function (value) {
	if (typeof value === 'undefined') return ''
	return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
}

// TODO: use native Array.find, Array.findIndex when IE support is dropped
export const arrayFindIndex = function (arr, pred) {
	for (let i = 0; i !== arr.length; ++i) {
		if (pred(arr[i])) {
			return i
		}
	}
	return -1
}

export const arrayFind = function (arr, pred) {
	const idx = arrayFindIndex(arr, pred)
	return idx !== -1 ? arr[idx] : undefined
}

// coerce truthy value to array
export const coerceTruthyValueToArray = function (val) {
	if (Array.isArray(val)) {
		return val
	} else if (val) {
		return [val]
	} else {
		return []
	}
}

// TODO: vue3版本重构
// export const isIE = function() {
// 	return !Vue.prototype.$isServer && !isNaN(Number(document.documentMode));
// }

// export const isEdge = function() {
// 	return !Vue.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
// }

// export const isFirefox = function() {
// 	return !Vue.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
// }

export const autoprefixer = function (style) {
	if (typeof style !== 'object') return style
	const rules = ['transform', 'transition', 'animation']
	const prefixes = ['ms-', 'webkit-']
	rules.forEach(function (rule) {
		const value = style[rule]
		if (rule && value) {
			prefixes.forEach(function (prefix) {
				style[prefix + rule] = value
			})
		}
	})
	return style
}

export const kebabCase = function (str) {
	const hyphenateRE = /([^-])([A-Z])/g
	return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase()
}

export const capitalize = function (str) {
	if (!isString(str)) return str
	return str.charAt(0).toUpperCase() + str.slice(1)
}

export const looseEqual = function (a, b) {
	const isObjectA = isObject(a)
	const isObjectB = isObject(b)
	if (isObjectA && isObjectB) {
		return JSON.stringify(a) === JSON.stringify(b)
	} else if (!isObjectA && !isObjectB) {
		return String(a) === String(b)
	} else {
		return false
	}
}

export const arrayEquals = function (arrayA, arrayB) {
	arrayA = arrayA || []
	arrayB = arrayB || []

	if (arrayA.length !== arrayB.length) {
		return false
	}

	for (let i = 0; i < arrayA.length; i++) {
		if (!looseEqual(arrayA[i], arrayB[i])) {
			return false
		}
	}

	return true
}

export const isEqual = function (value1, value2) {
	if (Array.isArray(value1) && Array.isArray(value2)) {
		return arrayEquals(value1, value2)
	}
	return looseEqual(value1, value2)
}

export const isEmpty = function (val) {
	// null or undefined
	if (val == null) return true

	if (typeof val === 'boolean') return false

	if (typeof val === 'number') return !val

	if (val instanceof Error) return val.message === ''

	switch (Object.prototype.toString.call(val)) {
		// String or Array
		case '[object String]':
		case '[object Array]':
			return !val.length

		// Map or Set or File
		case '[object File]':
		case '[object Map]':
		case '[object Set]': {
			return !val.size
		}
		// Plain Object
		case '[object Object]': {
			return !Object.keys(val).length
		}
	}

	return false
}

export function rafThrottle(fn) {
	let locked = false
	return function (...args) {
		if (locked) return
		locked = true
		window.requestAnimationFrame(function () {
			fn.apply(this, args)
			locked = false
		})
	}
}

export function objToArray(obj) {
	if (Array.isArray(obj)) {
		return obj
	}
	return isEmpty(obj) ? [] : [obj]
}

/* RSA 加密算法  */
export function rsaEncryptByPublicKey(data, pubKey) {
	if (!data || !isString(data)) {
		return data
	}

	const key = pubKey || publicRSAKey
	if (!key || !isString(key)) {
		return
	}

	const encrypt = new JSEncrypt()

	if (encrypt) {
		encrypt.setPublicKey(key)
		return encrypt.encrypt(data)
	} else {
		return data
	}
}

// 生成UUID
export function generateUUID() {
	const s = []
	const hexDigits = '0123456789abcdef'
	for (let i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
	}
	s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = s[23] = '-'
	const uuid = s.join('')
	return uuid
}

// 删除元素
export function removeElement(_element) {
	const _parentElement = _element.parentNode
	if (_parentElement) {
		_parentElement.removeChild(_element)
	}
}

/**
 *	判断是否是ipad 设备包括ipad Pro &ipad Air
 * @returns {boolean}
 */
export function isipadOS() {
	return (
		navigator.userAgent.match(/(iPad)/) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
	)
}

// 深拷贝
export function deepClone(target, map = new WeakMap()) {
	// 处理基本数据类型和 null
	if (typeof target !== 'object' || target === null) {
		return target
	}

	// 处理日期对象
	if (target instanceof Date) {
		return new Date(target.getTime())
	}

	// 处理正则表达式
	if (target instanceof RegExp) {
		return new RegExp(target)
	}

	// 处理 DOM 元素
	if (target instanceof Element) {
		return target.cloneNode(true)
	}

	// 检查循环引用
	if (map.has(target)) {
		return map.get(target)
	}

	// 创建新对象或数组
	const clone = Array.isArray(target) ? [] : {}
	map.set(target, clone)

	// 递归拷贝所有属性
	for (const key in target) {
		if (Object.prototype.hasOwnProperty.call(target, key)) {
			clone[key] = deepClone(target[key], map)
		}
	}

	return clone
}
